import React, { useState, ReactNode, useEffect } from "react";
import cn from "classnames";
import { IScrollableListItem } from "../scrollable-list";
import styles from "./scrollable-list-item.module.scss";


interface IScrollableListItemProps {
    actionButton?: ReactNode;
    id: string;
    onActionButtonClick?: (value: IScrollableListItem["value"]) => void;
    item: IScrollableListItem;
    onItemSelect: (value: IScrollableListItem["value"]) => void;
    selectedItem?: IScrollableListItem["value"]
}

export const ScrollableListItem: React.FC<IScrollableListItemProps> = React.memo(({
                                                                                      item,
                                                                                      id,
                                                                                      selectedItem,
                                                                                      onItemSelect,
                                                                                      actionButton,
                                                                                      onActionButtonClick,
                                                                                  }) => {
    const [hovered, setHovered] = useState(false);

    const onClickAction = (e: any) => {
        e.stopPropagation();
        onActionButtonClick && onActionButtonClick(item.value)
    }

    return <div className={cn(styles.listItem, item.value === selectedItem ? styles.selectedItem : "")}
                id={id}
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
                onClick={() => onItemSelect(item.value)}
    >
        <div>{item.name}</div>
        {hovered && <div onClick={onClickAction}>
            {actionButton}
        </div>}
    </div>
});
